export default "__VITE_ASSET__DsFO9j2h__"